module.exports = __webpack_public_path__ + "assets/images/boundaries/logo-elections.svg?v=c4f99441";